import Gator from 'gator';
import Headroom from 'headroom.js';
const documentElementClassList = document.documentElement.classList;
const header = document.querySelector('.header');
const dropdownClass = '-dropdownopen';
const notTopClass = '-not-top';
// const onHomepageAndLive = documentElementClassList.contains('-live') && documentElementClassList.contains('-home');
// const scroller = onHomepageAndLive ? document.body : window;
let prevScrollposHeaderHidden = window.scrollY;

if (header) {
    let hover = false;
    let focus = false;

    const headroom = new Headroom(header, {
        offset: 80,
        // scroller: scroller,
        onTop: () => {
            documentElementClassList.remove(notTopClass);
        },
        onNotTop: () => {
            documentElementClassList.add(notTopClass);
        },
    });
    headroom.init();

    Gator(header).on('mouseenter', () => {
        hover = true;
        documentElementClassList.add(dropdownClass);
    });

    Gator(header).on('mouseleave', () => {
        hover = false;
        if (!focus) {
            documentElementClassList.remove(dropdownClass);
        }
    });

    Gator(header).on('focus', 'a,button', () => {
        focus = true;
        documentElementClassList.add(dropdownClass);
    });

    Gator(header).on('blur', 'a,button', () => {
        focus = false;
        if (!hover) {
            documentElementClassList.remove(dropdownClass);
        }
    });
}

function switchHeader() {
    const currentScrollPos = window.scrollY;
    const directionUp = prevScrollposHeaderHidden > currentScrollPos;
    if(document.querySelector('.-mobilemenu-loaded')) {
        if (directionUp || currentScrollPos <= 120) {
            document.querySelector('.header').classList.remove('header--hidden')
            
            documentElementClassList.remove(notTopClass);
        } else {
            documentElementClassList.add(notTopClass);
            document.querySelector('.header').classList.add('header--hidden')
        }
    }
    prevScrollposHeaderHidden = currentScrollPos;
}

window.addEventListener('scroll', switchHeader, { passive: true });
